/**
 * Client Status Chip Component
 * Displays color-coded status chips for clients
 */

import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as ActiveIcon,
  Warning as AtRiskIcon,
  Block as InactiveIcon,
  Cancel as ChurnedIcon,
  Star as VIPIcon
} from '@mui/icons-material';
import type { ClientStatus } from '../types/client';

interface ClientStatusChipProps {
  status: ClientStatus;
  size?: 'small' | 'medium';
}

const statusConfig: Record<
  ClientStatus,
  { color: 'success' | 'warning' | 'error' | 'default' | 'secondary'; icon: React.ReactElement; label: string }
> = {
  ACTIVE: {
    color: 'success',
    icon: <ActiveIcon fontSize="small" />,
    label: 'Active'
  },
  INACTIVE: {
    color: 'default',
    icon: <InactiveIcon fontSize="small" />,
    label: 'Inactive'
  },
  AT_RISK: {
    color: 'warning',
    icon: <AtRiskIcon fontSize="small" />,
    label: 'At Risk'
  },
  CHURNED: {
    color: 'error',
    icon: <ChurnedIcon fontSize="small" />,
    label: 'Churned'
  },
  VIP: {
    color: 'secondary',
    icon: <VIPIcon fontSize="small" />,
    label: 'VIP'
  }
};

export const ClientStatusChip: React.FC<ClientStatusChipProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status];

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size={size}
      variant="filled"
    />
  );
};

export default ClientStatusChip;
